module.exports = __webpack_public_path__ + "img/photo.657c13df.jpg";